export const DAILY_MONITORING_TEST_IDS = {
  noFirmConfigAlert: 'daily-monitoring__no-firm-config-alert',
  noChangesHint: 'daily-monitoring__no-changes-hint',
  resetToFirmDefaultButton: (fieldKey: string) => `daily-monitoring__reset-to-firm-default-${fieldKey}`,
  thresholdSourceChip: (fieldKey: string) => `daily-monitoring__threshold-source-${fieldKey}`,
  alexandriaSection: 'daily-monitoring__alexandria-section',
  compsSection: 'daily-monitoring__comps-section',
  gpcApproachSelect: 'daily-monitoring__gpc-approach-select',
  copyFromGpcButton: 'daily-monitoring__copy-from-gpc-button',
  compsTable: 'daily-monitoring__comps-table',
  compTypeChip: (capIqId: string) => `daily-monitoring__comp-type-${capIqId}`,
  removeCompButton: (capIqId: string) => `daily-monitoring__remove-comp-${capIqId}`,
  noCompsHint: 'daily-monitoring__no-comps-hint',
  versionHistoryApplyButton: 'daily-monitoring__version-history-apply-button',
  versionHistoryApplyTooltip: 'daily-monitoring__version-history-apply-tooltip',
  applyConfirmDialog: 'daily-monitoring__apply-confirm-dialog',
  applyConfirmButton: 'daily-monitoring__apply-confirm-button',
} as const;
